@let relationTicketCategories =
  this.ticketCategoryStore.sortedRelationTicketCategories();
@let directTicketCategories =
  this.ticketCategoryStore.sortedDirectTicketCategories();
<aw-banner></aw-banner>
<div
  class="py-8"
  [ngStyle]="{
    color: corporateDesignService.fontColor(),
  }">
  <div class="top-0 z-10 w-full md:sticky">
    <div class="relative">
      <div
        class="top-0 right-0 w-full md:absolute md:w-1/3 md:pl-4"
        #shoppingCart>
        <aw-direct-ticket-configuration-shopping-cart
          class="fixed bottom-0 left-0 z-20 w-full md:relative"
          [attr.data-testid]="'ticket-option-configuration-page-shopping-cart'"
          [page]="EPage.Landing" />
      </div>
    </div>
  </div>
  <div
    [ngStyle]="{
      minHeight: isMobile() ? '' : minHeight() + 'px',
    }"
    class="flex w-full flex-col gap-5 pt-5 md:w-2/3 md:pt-0">
    @let isRelationSearch =
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsRelationSearchActive
      ) &&
      !configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsJourneyPlannerActive
      );
    @let isJourneyPlannerRedirect =
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsJourneyPlannerActive
      ) &&
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsJourneyPlannerRedirectActive
      );
    @let isJourneyPlannerSearch =
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsJourneyPlannerActive
      ) &&
      !configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsJourneyPlannerRedirectActive
      );
    @if (
      isRelationSearch || isJourneyPlannerRedirect || isJourneyPlannerSearch
    ) {
      <div class="pb-8">
        @if (isRelationSearch) {
          <aw-relation-search></aw-relation-search>
        }
        @if (isJourneyPlannerRedirect) {
          <aw-journey-planner [ctx]="ctx()"></aw-journey-planner>
        }
        @if (isJourneyPlannerSearch) {
          <div>Placeholder für Bedarfsverkehrsuche</div>
        }
      </div>
      <ng-container
        *ngTemplateOutlet="
          ticketDisplay;
          context: {
            isRelation: true,
            categories: relationTicketCategories,
            tickets: relationTickets(),
            isLoading: isLoadingRelationTickets(),
            headline:
              textStore.texts()
              | filterTexts
                : ERelationType.relationHeading
                : EEntityType.directTicket
              | language,
          }
        "></ng-container>
    }
    @if (
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsDirectSalesFixedPriceActive
      )
    ) {
      <ng-container
        *ngTemplateOutlet="
          ticketDisplay;
          context: {
            categories: directTicketCategories,
            tickets:
              directTicketCategories.length > 0
                ? visibleFixedPriceTickets()
                : fixedPriceTickets(),
            isLoading: isLoadingFixedPriceTickets(),
            headline:
              textStore.texts()
              | filterTexts
                : ERelationType.fixedPriceHeading
                : EEntityType.directTicket
              | language,
          }
        "></ng-container>
    }
  </div>
</div>

<ng-template
  #ticketDisplay
  let-isRelation="isRelation"
  let-tickets="tickets"
  let-categories="categories"
  let-headline="headline"
  let-isLoading="isLoading">
  @if (isLoading) {
    <div class="py-24">
      <aw-loading-animation
        [entityType]="EEntityType.ticket"
        [relationType]="ERelationType.loading"></aw-loading-animation>
    </div>
  } @else {
    @if (headline) {
      <div
        class="px-4 pt-4 text-center text-4xl font-semibold"
        [attr.data-testid]="'direct-ticket-headline' | appendTestId: headline">
        {{ headline }}
      </div>
    }

    @if (categories.length > 0) {
      <div class="flex flex-row flex-wrap justify-center gap-4">
        @for (ticketCategory of categories; track $index) {
          <div class="flex w-fit flex-col gap-2">
            <aw-toggle-chip
              [id]="ticketCategory.id! + '-chip'"
              [text]="ticketCategory.name"
              [attr.data-testid]="
                'toggle-button-display' | appendTestId: ticketCategory.name
              "
              (click)="selectTicketCategory(ticketCategory.id!)"
              [isChecked]="isCategoryChipSelected(ticketCategory.id)">
            </aw-toggle-chip>
          </div>
        }
      </div>
    }

    <div class="flex w-full flex-row flex-wrap">
      @for (ticket of tickets; track $index) {
        <aw-ticket-tile
          class="w-full p-1 sm:w-6/12 2xl:w-4/12"
          (onButtonClick)="
            orderTicketSupport.tryToOrderDirectTicket($event, isRelation)
          "
          (click)="equalize()"
          [id]="'ticket-' + $index"
          [ticket]="ticket | toTicketTile: ticket.name"></aw-ticket-tile>
      }
      @if (tickets.length === 0 && categories.length > 0) {
        <div
          class="text-semibold flex w-full justify-center text-center text-2xl">
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.noTicketFoundForCategory
                : EEntityType.ticketCategory
              | language
          }}
        </div>
      }
    </div>
  }
</ng-template>
